// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Comprobantes_container__RrDrc {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.Comprobantes_container__RrDrc .Comprobantes_header__nVpLU {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Comprobantes_container__RrDrc .Comprobantes_header__nVpLU .Comprobantes_titleContainer__fRobU {
  animation: Comprobantes_toright__iVmCC 0.3s;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Comprobantes_container__RrDrc .Comprobantes_header__nVpLU .Comprobantes_titleContainer__fRobU h4 {
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.Comprobantes_container__RrDrc .Comprobantes_filters__FIoRj {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Comprobantes_container__RrDrc .Comprobantes_filters__FIoRj .Comprobantes_item__u61N2 {
  animation: Comprobantes_init__yqcgz 0.5s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.Comprobantes_container__RrDrc .Comprobantes_filters__FIoRj .Comprobantes_init1__v-ksO {
  animation: Comprobantes_init__yqcgz 0.5s 0.2s both;
}
.Comprobantes_container__RrDrc .Comprobantes_filters__FIoRj .Comprobantes_init2__p-bKS {
  animation: Comprobantes_init__yqcgz 0.5s 0.4s both;
}
.Comprobantes_container__RrDrc .Comprobantes_filters__FIoRj .Comprobantes_init3__k2vjx {
  animation: Comprobantes_init__yqcgz 0.5s 0.6s both;
}

.Comprobantes_container__RrDrc .Comprobantes_loader__yZQro {
  animation: Comprobantes_init__yqcgz 0.5s both;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.Comprobantes_container__RrDrc .Comprobantes_loader__yZQro p {
  font-size: 1.8rem;
  font-weight: 300;
}

.Comprobantes_container__RrDrc .Comprobantes_data__Jffts .Comprobantes_tableContainer__8Iv3r {
  animation: Comprobantes_toleft__vO5fL 0.3s both;
  border-radius: 5px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Comprobantes_container__RrDrc .Comprobantes_data__Jffts .Comprobantes_tableContainer__8Iv3r .Comprobantes_tableHeader__l6wfU {
  font-size: 0.9rem;
  font-weight: 500;
}

.Comprobantes_container__RrDrc .Comprobantes_options__HW2z2 {
  animation: Comprobantes_toright__iVmCC 0.5s 1s both;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.Comprobantes_container__RrDrc .Comprobantes_options__HW2z2 p {
  margin: 0 0 0 10px;
  text-transform: capitalize;
  font-weight: 300;
}

@keyframes Comprobantes_init__yqcgz {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes Comprobantes_toright__iVmCC {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes Comprobantes_toleft__vO5fL {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@media print {
  @page {
    size: landscape;
    margin: 50px 0 50px;
    quotes: none;
    visibility: visible;
  }

  .Comprobantes_container__RrDrc .Comprobantes_header__nVpLU {
    display: none !important;
  }

  .Comprobantes_container__RrDrc .Comprobantes_filters__FIoRj {
    display: none !important;
  }

  .Comprobantes_container__RrDrc .Comprobantes_options__HW2z2 {
    display: none !important;
  }

  .Comprobantes_container__RrDrc .Comprobantes_data__Jffts {
    min-width: 99%;
  }

  .Comprobantes_container__RrDrc .Comprobantes_data__Jffts .Comprobantes_tableContainer__8Iv3r {
    box-shadow: none;
    border-radius: 0;
  }

  .Comprobantes_tableTitle__MoETL {
    color: black !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Comprobantes/Comprobantes.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2CAAuB;EACvB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,6CAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kDAA8B;AAChC;AACA;EACE,kDAA8B;AAChC;AACA;EACE,kDAA8B;AAChC;;AAEA;EACE,6CAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+CAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mDAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: toright 0.3s;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .filters .item {\n  animation: init 0.5s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.container .filters .init1 {\n  animation: init 0.5s 0.2s both;\n}\n.container .filters .init2 {\n  animation: init 0.5s 0.4s both;\n}\n.container .filters .init3 {\n  animation: init 0.5s 0.6s both;\n}\n\n.container .loader {\n  animation: init 0.5s both;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.container .loader p {\n  font-size: 1.8rem;\n  font-weight: 300;\n}\n\n.container .data .tableContainer {\n  animation: toleft 0.3s both;\n  border-radius: 5px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .tableHeader {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.container .options {\n  animation: toright 0.5s 1s both;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.container .options p {\n  margin: 0 0 0 10px;\n  text-transform: capitalize;\n  font-weight: 300;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes toright {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes toleft {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@media print {\n  @page {\n    size: landscape;\n    margin: 50px 0 50px;\n    quotes: none;\n    visibility: visible;\n  }\n\n  .container .header {\n    display: none !important;\n  }\n\n  .container .filters {\n    display: none !important;\n  }\n\n  .container .options {\n    display: none !important;\n  }\n\n  .container .data {\n    min-width: 99%;\n  }\n\n  .container .data .tableContainer {\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  .tableTitle {\n    color: black !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Comprobantes_container__RrDrc`,
	"header": `Comprobantes_header__nVpLU`,
	"titleContainer": `Comprobantes_titleContainer__fRobU`,
	"toright": `Comprobantes_toright__iVmCC`,
	"filters": `Comprobantes_filters__FIoRj`,
	"item": `Comprobantes_item__u61N2`,
	"init": `Comprobantes_init__yqcgz`,
	"init1": `Comprobantes_init1__v-ksO`,
	"init2": `Comprobantes_init2__p-bKS`,
	"init3": `Comprobantes_init3__k2vjx`,
	"loader": `Comprobantes_loader__yZQro`,
	"data": `Comprobantes_data__Jffts`,
	"tableContainer": `Comprobantes_tableContainer__8Iv3r`,
	"toleft": `Comprobantes_toleft__vO5fL`,
	"tableHeader": `Comprobantes_tableHeader__l6wfU`,
	"options": `Comprobantes_options__HW2z2`,
	"tableTitle": `Comprobantes_tableTitle__MoETL`
};
export default ___CSS_LOADER_EXPORT___;
